// src/admin/AdminDashboard.js
import { Link } from "react-router-dom";
import "./Admin.css";

export default function AdminDashboard() {
  return (
    <div className="admin-page">

      <div className="admin-page__top">
        <div>
          <h1 className="admin-page__title">hellastay Admin Panel</h1>
          <p className="admin-page__subtitle">
            Manage properties, bookings and platform activity.
          </p>
        </div>
      </div>

      {/* Quick stats */}
      <div className="admin-statsRow">
        <div className="admin-statCard">
          <span className="admin-statCard__label">Properties</span>
          <strong className="admin-statCard__value">—</strong>
        </div>

        <div className="admin-statCard">
          <span className="admin-statCard__label">Bookings</span>
          <strong className="admin-statCard__value">—</strong>
        </div>

        <div className="admin-statCard">
          <span className="admin-statCard__label">Platform status</span>
          <strong className="admin-statCard__value">Active</strong>
        </div>
      </div>

      {/* Navigation cards */}
      <div className="admin-grid">

        <Link to="/admin/properties" className="admin-card">
          <h2>🏠 Properties</h2>
          <p>Approve, reject or manage property listings.</p>
        </Link>

        <Link to="/admin/bookings" className="admin-card">
          <h2>📅 Bookings</h2>
          <p>View reservations, guests and booking totals.</p>
        </Link>

      </div>

    </div>
  );
}